export default __webpack_public_path__ + "static/media/felcha_izquierda.0f74b177.svg";